import { render } from "./page-home.vue?vue&type=template&id=adea8d68"
import script from "./page-home.vue?vue&type=script&lang=js"
export * from "./page-home.vue?vue&type=script&lang=js"

import "./page-home.vue?vue&type=style&index=0&id=adea8d68&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__